import { render, staticRenderFns } from "./Supervirorio.vue?vue&type=template&id=bdaaad40"
import script from "./Supervirorio.vue?vue&type=script&lang=js"
export * from "./Supervirorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports